module.exports = __webpack_public_path__ + "static/media/buscar-logo-light.ff9ea24b.png";